export enum TipoDocumentoCode {
    FotoOficina = "FOTO_OFICINA"
}

export enum ServiceHandlerCode {
    EjecutarOperacionEspecifica = "TIPO_TRAMITE_PASO_TIPO_OPERACION_EJECUTAR_OPERACION_CUSTOM",
    EnviarComprobanteTramite = "EnviarComprobanteTramite",
    CompartirDatosTramite = "CompartirDatosTramite",
}

export enum NameValueCode {
    SolicitudUsuarioEstado = 'SOLICITUD_USUARIO_ESTADO',
    SolicitudUsuarioEstadoAceptada = 'SOLICITUD_USUARIO_ESTADO_COMPLETADA',
    SolicitudUsuarioEstadoRechazada = 'SOLICITUD_USUARIO_ESTADO_RECHAZADA',
    SolicitudUsuarioEstadoEnviada = 'SOLICITUD_USUARIO_ESTADO_ENVIADA',
    SolicitudUsuarioEstadoAbierta = 'SOLICITUD_USUARIO_ESTADO_ABIERTA',
    TipoTramitePasoOperacion = "TIPO_TRAMITE_PASO_TIPO_OPERACION",
    TipoTramitePrioridad = "TIPO_TRAMITE_PRIORIDAD",
    ParentTramiteEstadoCode = "Estado",
    ParentPrioridadCode = "Prioridad",
    ParentOrigenCode = "Origen",
    ParentAuditoriaAccionCode = "AUDITORIA_ACCION",
    ConsultaTipoServicioCode = "CONSULTA_TIPO_SERVICIO",
    TramiteTodosEstadosCode = "TODOS_LOS_ESTADOS", // Crear este namevalue hijo de: Estado
    ConsultaTodosLosTiposDeServicioCode = "CONSULTA_TODOS_LOS_TIPOS_DE_SERVICIO", // crear este namevalue hijo de: Tipos de servicios en la consulta
}


export enum AvisoUsuarioTipoContenido {
    Imagen = 0,
    Video = 1
}
export enum CuentaEstado {
    Activa = '00',
    Suspendida = '01',
    Cancelada = '02'
}
export enum TipoCiudadano {
    Participante = 'Beneficiario',
    Evaluado = 'Evaluado',
    NoEvaluado = 'NoEvaluado'
}
export enum AppNotificationType {
    TRAMITE_COMPLETADO = 0,
    TRAMITE_RECHAZADO = 1,
    PSONLINE_TRAMITE_COMENTADO = 2,
    PSINFO_ACTIVIDAD_CREADA = 3,
    SOLICITUD_USUARIO_CREADA = 4,
    SOLICITUD_USUARIO_ACEPTADA = 5,
    SOLICITUD_USUARIO_RECHAZADA = 6
}